import { apiDelete } from '../support/helpers/ApiConnection.Helper';

export default function deleteDestinationInformation(id: number, abortSignal: AbortSignal): Promise<void> {
    return apiDelete<void>('/destination-information', id, abortSignal);
}
